module.exports = __webpack_public_path__ + "img/pick5_yellow.3293c9d5.png";